export default "__VITE_ASSET__d516ae93__"